import { useTranslation } from "react-i18next";
import {
  OrderFulfillmentStatus,
  OrderItemProcessStatus,
  OrderStatus,
  PickingItemStatus,
} from "../../../../../../enums/Orders";

export const useTranslateStatus = () => {
  const { t } = useTranslation();

  const translateOrderStatus = (status: OrderStatus) => {
    const translatedOrderStatus: Record<string, string> = {
      SUCCESS: t("success"),
      ERROR: t("error"),
      UNPROCESSABLE: t("unprocessable"),
      PARTIALLY_PROCESSED: t("partiallyProcessed"),
      CANCELLED: t("canceled"),
      REFUNDED: t("refunded"),
      PARTIALLY_REFUNDED: t("partiallyRefunded"),
    };

    return translatedOrderStatus[status] || status;
  };

  const translateFulfillmentStatus = (status: OrderFulfillmentStatus) => {
    const translatedFulfillmentStatus: Record<OrderFulfillmentStatus, string> = {
      [OrderFulfillmentStatus.DROPSHIP]: t("dropship"),
      [OrderFulfillmentStatus.PENDING]: t("pending"),
      [OrderFulfillmentStatus.PARTIALLY_PICKED]: t("partiallyPicked"),
      [OrderFulfillmentStatus.PICKED]: t("picked"),
      [OrderFulfillmentStatus.SHIPPED]: t("shipped"),
      [OrderFulfillmentStatus.CANCELED]: t("canceled"),
      [OrderFulfillmentStatus.ARCHIVED]: t("archived"),
    };

    return translatedFulfillmentStatus[status] || status;
  };

  const translateItemProcessStatus = (status: OrderItemProcessStatus) => {
    const statusTranslations = {
      CANCELLED: t("canceled"),
      CANCELED: t("canceled"),
      REFUNDED: t("refunded"),
      PARTIALLY_REFUNDED: t("partiallyRefunded"),
      PARTIALLY_PICKED: t("partiallyPicked"),
      PICKED: t("picked"),
      PICKING: t("picking"),
      PENDING: t("pending"),
      SHIPPED: t("shipped"),

      NEW: t("new"),
      ERROR: t("error"),
      SUCCESS: t("success"),
    };

    return statusTranslations[status] || status;
  };

  const translatePickingItemStatus = (status: PickingItemStatus) => {
    const pickingItemStatusConverter = {
      CANCELLED: t("canceled"),
      CANCELED: t("canceled"),
      REFUNDED: t("refunded"),
      PARTIALLY_REFUNDED: t("partiallyRefunded"),
      PARTIALLY_PICKED: t("partiallyPicked"),
      PICKED: t("picked"),
      PICKING: t("picking"),
      PENDING: t("pending"),
      SHIPPED: t("shipped"),
    };

    return pickingItemStatusConverter[status] || status;
  };

  return {
    translateFulfillmentStatus,
    translateOrderStatus,
    translateItemProcessStatus,
    translatePickingItemStatus,
  };
};
